var _ArrayEnumerator_baseArray, _ArrayEnumerator_pointer;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import EnumeratorBase from "./EnumeratorBase";
import OutOfBoundsException from '../Exceptions/OutOfBoundsException';
export default class ArrayEnumerator extends EnumeratorBase {
    /**
     * Enumerate an array.
     * @param array The array to enumerate.
     * @param immutable True means the enumerator takes a copy of the array. False uses the array.
     */
    constructor(array, immutable = true) {
        super();
        // the internal array
        _ArrayEnumerator_baseArray.set(this, void 0);
        // current pointer location
        _ArrayEnumerator_pointer.set(this, -1);
        if (immutable) {
            // copy the array to make this immutable.
            __classPrivateFieldSet(this, _ArrayEnumerator_baseArray, [...array], "f");
        }
        else {
            __classPrivateFieldSet(this, _ArrayEnumerator_baseArray, array, "f");
        }
    }
    // returns the current element
    get current() {
        if (__classPrivateFieldGet(this, _ArrayEnumerator_pointer, "f") >= __classPrivateFieldGet(this, _ArrayEnumerator_baseArray, "f").length || __classPrivateFieldGet(this, _ArrayEnumerator_pointer, "f") < 0) {
            this.throwOutOfBoundsException();
        }
        return __classPrivateFieldGet(this, _ArrayEnumerator_baseArray, "f")[__classPrivateFieldGet(this, _ArrayEnumerator_pointer, "f")];
    }
    moveNext() {
        var _a;
        if (__classPrivateFieldGet(this, _ArrayEnumerator_pointer, "f") < __classPrivateFieldGet(this, _ArrayEnumerator_baseArray, "f").length) {
            __classPrivateFieldSet(this, _ArrayEnumerator_pointer, (_a = __classPrivateFieldGet(this, _ArrayEnumerator_pointer, "f"), _a++, _a), "f");
        }
        return __classPrivateFieldGet(this, _ArrayEnumerator_pointer, "f") < __classPrivateFieldGet(this, _ArrayEnumerator_baseArray, "f").length;
    }
    // returns the next element without moving the pointer forwards
    peek() {
        if (__classPrivateFieldGet(this, _ArrayEnumerator_pointer, "f") + 1 >= __classPrivateFieldGet(this, _ArrayEnumerator_baseArray, "f").length) {
            return;
        }
        return __classPrivateFieldGet(this, _ArrayEnumerator_baseArray, "f")[__classPrivateFieldGet(this, _ArrayEnumerator_pointer, "f") + 1];
    }
    // reset the pointer to the start
    reset() {
        __classPrivateFieldSet(this, _ArrayEnumerator_pointer, -1, "f");
    }
    throwOutOfBoundsException() {
        throw new OutOfBoundsException("internal pointer", 0, __classPrivateFieldGet(this, _ArrayEnumerator_baseArray, "f").length - 1);
    }
}
_ArrayEnumerator_baseArray = new WeakMap(), _ArrayEnumerator_pointer = new WeakMap();
